import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

type FormPageWrapperProps = {
  title?: string;
  children: ReactNode;
};

export default function FormPageWrapper({ title = "", children }: FormPageWrapperProps) {
  return (
    <Box
      minHeight="20vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="#f9f9f9"
    >
      <Paper
        elevation={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: 4,
          p: 5,
          width: "100%",
          maxWidth: 900,
        }}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          mb={4}
          color="primary"
          textAlign="center"
        >
          {title}
        </Typography>
        {children}
      </Paper>
    </Box>
  );
}
